import cx from "classnames";
import { Button, Modal, TranslatedString, Image } from "components";
import React from "react";
import "./styles.scss";
import { CodeExampleModalProps } from "./types";
const CodeExampleModal: React.FC<CodeExampleModalProps> = ({
  visible,
  path,
  onClose,
}) => {
  return (
    <Modal
      modalHeader={<TranslatedString text="Example" />}
      onClose={onClose}
      visible={visible}
      className="CodeExample-modal"
    >
      <Image src={path} className="w-100" />
    </Modal>
  );
};
export default CodeExampleModal;
